import React, { FC, useEffect, useState } from "react";
import "./ForgetPassword.scss";
import axios from "../../../utils/axios";

import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import BaseDialog from "../../../modelDialogs/BaseDialog";

import LanguagePicker from "../../../LanguagePicker";
import { RequiredLabel } from "../Login/Login";
import GlobalWaitIndicator from "../../GlobalWaitIndicator";
import { itx, noItx } from "../../../translationItx/itx";

interface ForgetPasswordProps {}
function ErrorMessage(props: { className: string; text: string }) {
  const { text, className } = props;
  return (
    <div className={className} style={{ padding: "5px" }}>
      {text}
    </div>
  );
}

const ForgetPassword: FC<ForgetPasswordProps> = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [buttonClicked, setButtonClicked] = useState(false);

  useEffect(() => {
    state._navigate = navigate;
  }, []);

  function attInsideInput(): boolean {
    if (email.includes("@") && email.includes(".")) {
      return true;
    }
    return false;
  }

  function handleSubmit() {
    axios
      .post("/api/forget/password", { email: email })
      .then((result: any) => {
        if (result.data) {
          let title = state.translate("Success", "Erfolg");
          let text = result.data.MESSAGE;

          const textMap = new Map<string, string>();
          textMap.set(
            "If we found an account associated with that username, we've sent password reset instructions to the primary email address on the account.", // no itx
            state.translate(
              "forgotPassword.resetPasswordText",
              "Wenn wir ein Konto gefunden haben, das mit diesem Benutzernamen verknüpft ist, haben wir Anweisungen zum Zurücksetzen des Passworts an die primäre E-Mail-Adresse des Kontos gesendet.",
            ),
          );
          textMap.forEach((value, key) => {
            if (key == result.data.MESSAGE) {
              text = value;
            }
          });

          state.dialogManager.openDialog(
            <BaseDialog
              className="dialog-standard"
              title={title}
              onOk={() => {
                state.navigate("/login");
                return true;
              }}
              okCaption={state.translate("ok", "Ok")}
              noAbortButton={true}
            >
              <div style={{ padding: "20px" }}>{text}</div>
            </BaseDialog>,
          );
        }
      })
      .catch((e) => {
        let title = e;
        let context = "";
        if (title.MESSAGE) {
          title = e.MESSAGE;
        }
        if (e.DATA) {
          context = e.DATA;
        }
        state.dialogManager.openDialog(
          <BaseDialog
            className="dialog-standard"
            title={title}
            onOk={() => {
              return true;
            }}
            okCaption={state.translate("ok", "Ok")}
            noAbortButton={true}
          >
            <div style={{ padding: "20px" }}>{context}</div>
          </BaseDialog>,
        );
      });
  }
  return (
    <div id="App" className="App">
      <div className="ForgetPassword main-form">
        <div className="lView">
          <div className="head">
            <div className="logo" style={{ cursor: "default" }}>
              <img src={`${state.hostBaseUrl}images/logo.png`} />
              <span className="logoText">{noItx("ESTADA")}</span>
            </div>
            <span className="title form-title">
              {state.translate("forgotPassword.forgotPassword?", "Forget Password")}
            </span>
          </div>
          <div className="seperator invisible">
            <div />
            <div />
          </div>
          <div style={{ width: "100%", maxWidth: "450px" }}>
            <div className="inp">
              <label
                className="field-container"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                <span className="form-label">
                  {/* {state.translate("loginPage.email", "E-mail")} <RequiredLabel /> */}
                </span>
                <span className="form-span input-container">
                  <i className="la la-envelope la-lg input-icon" />
                  <input
                    className="form-input input-field"
                    placeholder={""}
                    maxLength={state.maxCharLimit.text}
                    onChange={(ev) => {
                      setEmail(ev.target.value);
                    }}
                    onBlur={() => {
                      if (email != "") {
                        setButtonClicked(true);
                      }
                    }}
                    style={{
                      border: "1px solid white",
                      width: "100%",
                    }}
                  ></input>
                  {/* <Field type="email" name={state.translate("loginPage.email", "email")} /> */}
                  <label className="input-label">
                    {state.translate("loginPage.email", "Email")}
                    <RequiredLabel />
                  </label>
                </span>
                {buttonClicked && !attInsideInput() && (
                  <ErrorMessage
                    className="form-error"
                    text={state.translate("inviteUserDialog.pleaseCorrectEmail", "Bitte gib eine korrekte Email ein ")}
                  />
                )}
              </label>
            </div>
            <div className="endItems" style={{ marginTop: "30px" }}>
              <button
                disabled={!attInsideInput()}
                className="confirm-button button-full"
                type="submit" // no itx
                onClick={() => {
                  setButtonClicked(true);
                  handleSubmit();
                }}
              >
                <span>{state.translate("forgotPassword.resetPassword", "Passwort zurücksetzen")}</span>
              </button>
              <span className="info">
                {state.translate("register.accountAlreadyavailable?", "You already have an Account?")}{" "}
                <Link className="form-link" to={noItx("/login")}>
                  {state.translate("loginPage.signIn", "Sign in!")}
                </Link>
              </span>
            </div>
          </div>
        </div>
        <div className="rView">
          <img
            src="/images/auth/rView.png" // no itx
            alt="" // no itx
          />
        </div>
        <LanguagePicker className="language-picker" />
        {/* <DialogHost /> */}
      </div>

      <GlobalWaitIndicator />
    </div>
  );
};

export default ForgetPassword;
